import React from 'react';
import { useAcceptVto } from '../../../hooks';
import { useAcceptVtoContext } from '../../../context';
import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next';
export var useAcceptVtoModalData = function (_a) {
    var setModalContent = _a.setModalContent, setModalError = _a.setModalError;
    var t = useTranslation().t;
    var state = useAcceptVtoContext()[0];
    if (!state.selectedVto) {
        throw new Error('Accept VTO rendered without a selected VTO');
    }
    var _b = useAcceptVto({
        vtoOpportunity: state.selectedVto,
        setModalContent: setModalContent,
        setModalError: setModalError
    }), acceptVtoMutation = _b.acceptVtoMutation, loading = _b.useAcceptVtoState.loading;
    // We need to bold the inside part of message, so split it up using placeholder
    var _c = t('shift_management_features_VtoAcceptConfirmationModal_vtoAcceptMessage', { vto_description: '{{vto_description}}' }).split('{{vto_description}}'), vtoMessage1 = _c[0], vtoMessage2 = _c[1];
    var vtoDescription = React.useMemo(function () {
        /* eslint-disable @typescript-eslint/no-non-null-assertion */
        var startText = state.selectedVto.shift.timeRange.start;
        var endText = state.selectedVto.shift.timeRange.end;
        /* eslint-enable @typescript-eslint/no-non-null-assertion */
        var parsedStart = DateTime.fromISO(startText);
        var parsedEnd = DateTime.fromISO(endText);
        var diffHours = parsedEnd.diff(parsedStart, ['hours']);
        return t('shift_management_features_VtoAcceptConfirmationModal_vtoTimeDetails', {
            start_time: parsedStart.toFormat('hh:mm a'),
            end_time: parsedEnd.toFormat('hh:mm a'),
            duration: diffHours.toObject().hours +
                t('shift_management_common_time_hourAbbr'),
            date: parsedStart.toFormat('LLLL d, yyyy (cccc)')
        });
    }, [state.selectedVto]);
    return {
        acceptVtoMutation: acceptVtoMutation,
        isAcceptVtoSubmitting: loading,
        vtoDescription: vtoDescription,
        vtoMessage1: vtoMessage1,
        vtoMessage2: vtoMessage2
    };
};
